module.exports = __webpack_public_path__ + "static/media/BG2.dfbb29df.jpg";